import { apiClient } from './client';

export type FeedbackRating = 'up' | 'down';

export interface SubmitFeedbackPayload {
  sessionId: string;
  messageId: string;
  rating: FeedbackRating;
  comment?: string | null;
  channel?: string | null;
  routeCanonicalAction?: string | null;
  responseIntentType?: string | null;
  routeLane?: string | null;
  routeIntent?: string | null;
  customerIdHash?: string | null;
  meta?: Record<string, unknown> | null;
}

export const submitFeedback = async (payload: SubmitFeedbackPayload): Promise<void> => {
  await apiClient.post('/feedback', payload);
};

export const removeFeedback = async (sessionId: string, messageId: string): Promise<void> => {
  await apiClient.delete('/feedback', {
    data: { sessionId, messageId },
  });
};
